class SideNav {


    init() {
        // Default to not use-fixed
        $("body").on("click", '.collapseMenu', function () {
            $(this).html('+');
            $(this).closest('.subItem').find('ul.level3').hide();
            $(this).removeClass('collapseMenu').addClass('expandMenu');
        });
        $("body").on("click", '.expandMenu', function () {
            $(this).html('-');
            $(this).closest('.subItem').find('ul.level3').show();
            $(this).removeClass('expandMenu').addClass('collapseMenu');
        });
    }

}

export default SideNav;
